// 答卷页列表字段
export const answerSheetListOptions = {
  column: [
    {
      width: 170,
      label: '答卷ID',
      value: 'answerId',
      fixed: true
    },
    {
      width: 110,
      label: '结算状态',
      value: 'settleStatus'
    },
    {
      width: 110,
      label: '任务ID',
      value: 'entrustTaskId'
    },
    {
      width: 110,
      label: '调查员',
      value: 'executorName'
    },
    {
      width: 110,
      label: '调查员手机号',
      value: 'executorPhone'
    },
    {
      width: 100,
      label: '答卷单价（元）',
      value: 'singleAmount'
    },
    {
      label: '调价金额（元）',
      value: 'adjustAmount'
    },
    {
      width: 120,
      label: '结算费用（元）',
      value: 'realAmount',
      renderHeader: (h, { column, $index }) => {
        return h('div', { class: 'tips', style: { display: 'inline' } }, [
          h('span', column.label),
          h(
            'el-tooltip',
            {
              style: {
                position: 'relative',
                left: '50px',
                top: '-25px'
              },
              attrs: {
                class: 'item',
                effect: 'light',
                content: '调整后，实际发放的答卷费用',
                placement: 'top-start'
              }
            },
            [
              h('img', {
                attrs: {
                  src: process.env.BASE_URL + 'img/tips_red.png',
                  width: 14
                }
              })
            ]
          )
        ])
      }
    },
    {
      width: 330,
      label: '调价说明',
      value: 'adjustDescribe'
    },
    {
      width: 220,
      label: '关联结算单',
      value: 'statementId'
    },
    {
      label: '操作',
      value: 'opt',
      width: 150,
      fixed: 'right'
    }
  ]
}

// 结算单列表字段
export const settlementBillListOptions = {
  column: [
    {
      width: 170,
      label: '结算单号',
      value: 'id',
      fixed: true
    },
    {
      width: 110,
      label: '结算单状态',
      value: 'settleStatus'
    },
    {
      label: '调查员',
      value: 'executorName'
    },
    {
      label: '调查员手机号',
      value: 'executorPhone'
    },
    {
      width: 100,
      label: '答卷数量',
      value: 'answerNum'
    },
    {
      width: 100,
      label: '答卷费用（元）',
      value: 'totalAmount'
    },
    {
      label: '调价金额（元）',
      value: 'adjustAmount'
    },
    {
      width: 105,
      label: '调查员到手金额（元）',
      value: 'realAmount'
    },
    {
      width: 105,
      label: '服务费（元）',
      value: 'serviceFee'
    },
    {
      width: 105,
      label: '结算总费用（元）',
      value: 'totalSettlement'
    },
    {
      width: 330,
      label: '调价说明',
      value: 'adjustDescribe'
    },
    {
      width: 220,
      label: '支付方式',
      value: 'payType'
    },
    {
      label: '银行卡号',
      value: 'bankCardNumber'
    },
    {
      label: '开户行信息',
      value: 'bankCardInfo'
    },
    {
      width: 120,
      label: '联系方式',
      value: 'executorPhone'
    },
    {
      label: '操作',
      value: 'opt',
      width: 350,
      fixed: 'right'
    }
  ]
}

export const publicPage = {
  total: 0,
  currentPage: 1,
  pageSize: 20,
  pageSizes: [10, 20, 30, 50, 100],
  background: true
}
